import { axiosv2 } from "@/api/base/API";

export default {
    getAnInteraction(idMuseum, interactionId, lang) {
        return axiosv2.get(`v1/admin/museum/${idMuseum}/interaction/${interactionId}/${lang}`)
            .then((response) => {
                const { data } = response;
                return data;
            })
            .catch((error) => {
                console.log('error', error);
            });
    },

    setAllInteraction(idMuseum, lang) {
        const localInteractions = localStorage.getItem("interactions");
        const localeInteractionLang = localInteractions && JSON.parse(localStorage.getItem("interactions"))[0].locale;
        console.log('lang', lang);
        console.log('localeInteractionLang', localeInteractionLang);
        if (!localInteractions || localeInteractionLang !== lang) {
            return axiosv2.get(`v1/admin/museum/${idMuseum}/interaction/${lang}?page=1&itemsPerPage=200&isActive=true`)
                .then((response) => {
                    const { data } = response;
                    const dataInteraction = data.results;

                    window.localStorage.setItem("interactions", JSON.stringify(dataInteraction));
                })
                .catch((error) => {
                    console.log('error', error);
                });
        }
    },
};

